import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/tech.png";




export default function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setOpenDropdown(null);

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  };

  return (
    <nav className="navbar">
      <div className="nav-container">

        {/* LOGO */}
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <img src={logo} alt="logo" />
        </Link>

        {/* HAMBURGER */}
        <button className="hamburger" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* MENU */}
        <div className={`nav-links ${menuOpen ? "open" : ""}`}>

          <Link
            to="/"
            className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
            onClick={closeMenu}
          >
            Home
          </Link>

          <Link
            to="/about"
            className={`nav-link ${location.pathname === "/about" ? "active" : ""}`}
            onClick={closeMenu}
          >
            About
          </Link>

          {/* SERVICES */}
          <div className={`dropdown ${openDropdown === "services" ? "open" : ""}`}>

            <div
              className="nav-link dropdown-trigger"
              onClick={() => toggleDropdown("services")}
            >
              Services <span className="arrow">▾</span>
            </div>

            <div className="dropdown-menu">

              <Link to="/services" className="dropdown-item" onClick={closeMenu}>
                All Services
              </Link>

              <Link to="/services/social-media-marketing" className="dropdown-item" onClick={closeMenu}>
                Social Media Marketing
              </Link>

              <Link to="/services/social-media-optimization" className="dropdown-item" onClick={closeMenu}>
                Social Media Optimization
              </Link>

              <Link to="/services/whatsapp-marketing" className="dropdown-item" onClick={closeMenu}>
                WhatsApp Marketing
              </Link>

              <Link to="/services/google-ads" className="dropdown-item" onClick={closeMenu}>
                Google Ads
              </Link>

              <Link to="/services/meta-ads" className="dropdown-item" onClick={closeMenu}>
                Meta Ads
              </Link>

              <Link to="/services/website-design" className="dropdown-item" onClick={closeMenu}>
                Website Design
              </Link>

            </div>
          </div>

          <Link
            to="/contact"
            className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`}
            onClick={closeMenu}
          >
            Contact
          </Link>

        </div>

        {/* CTA BUTTON */}
        <Link to="/contact" className="nav-cta" onClick={closeMenu}>
          Get Quote
        </Link>

      </div>
    </nav>
  );
}